import classes from "@/styles/fulfilment-partners/ups-canada-main.module.css";
import { upsUS } from "@/utils/content";
import Image from "next/image";
import { FaDotCircle, FaTruck } from "react-icons/fa";
import { BiCurrentLocation } from "react-icons/bi";
import { GiEarthAmerica } from "react-icons/gi";
import {
  Accordion,
  AccordionBody,
  AccordionHeader,
  AccordionItem,
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Row,
} from "reactstrap";
import Link from "next/link";
import { useState } from "react";
import IntegrationDetails from "../partners/integration-details";
import UPSCountrySelect from "./ups-country-select";
import { useIsMobile } from "@/hooks/useIsMobile";
import { useRouter } from "next/router";
import { routes } from "@/utils/routes";
import { MdChevronRight } from "react-icons/md";
// import { dashboardUrl } from "@/utils/constants";
// import { useIsAuthenticated } from "@/hooks/useIsAuthenticated";

export default function UpsUSMain() {
  const content = upsUS.en;
  const router = useRouter();

  const [open, setOpen] = useState<string>("1");
  const isMobile = useIsMobile();

  //@ts-ignore
  const toggle = (id) => {
    if (open === id) {
      //@ts-ignore
      setOpen();
    } else {
      setOpen(id);
    }
  };

  // const isAuthenticated = useIsAuthenticated();

  // const goToUPSSignUpFormLink = () => {
  //   let url = ``;
  //   if (isAuthenticated){
  //     url += `${dashboardUrl}/ups-signup`;
  //     window.location.href = url;
  //   }else{
  //     url += `${routes.login}?redirect=/ups-signup`;
  //     router.push(url);
  //   }
  // }

  return (
    <main className={classes.container}>
      <section className={classes.hero}>
        <Container>
          <div className={classes.heroGrid}>
            <h1 className="text-white w-50">{content.hero.title}</h1>
            <Image
              src={content.hero.img1}
              alt={content.hero.img1}
              height={200}
              width={200}
            />
          </div>
        </Container>
      </section>
      {/* section1 */}
      <section className="my-5 container">
        {/* <p className={`fw-bold mb-4 ${isMobile ? "" : "w-75"}`}>
          {content.section1.note}
        </p> */}
        <Row>
          <Col xs={12} sm={8}>
            <h2>{content.section1.title}</h2>
          </Col>
          <Col xs={12} sm={4}>
            <UPSCountrySelect
              selectedCountry={{ label: "United States", value: "ups-usa" }}
            />
          </Col>
        </Row>
        <p className={`${classes.aboutPara} ${isMobile ? "" : "w-75"}`}>
          {content.section1.para}
        </p>
      </section>
      {/* section2 */}
      <section className="my-5 container">
        <Row>
          <Col xs={12} lg={7}>
            <h3>{content.section2.title} </h3>
            <p>{content.section2.para}</p>
          </Col>
          <Col
            className="d-flex justify-content-center align-items-center"
            xs={12}
            lg={5}
          >
            <Button
              onClick={() => router.push(routes.register)}
              className="btn-brown btn-lg"
            >
              {content.section2.btnText} <MdChevronRight />
            </Button>
          </Col>
        </Row>
      </section>
      {/* section3 */}
      <section className="my-5 container">
        <Row>
          <Col xs={12} lg={3}>
            {content.section3.list2.map((l, i) => (
              <div className="d-flex align-items-center my-4" key={i}>
                <div className={classes.icoWrapper}>
                  {i === 0 && <FaDotCircle className={classes.ico} size={20} />}
                  {i === 1 && (
                    <BiCurrentLocation className={classes.ico} size={20} />
                  )}
                  {i === 2 && (
                    <GiEarthAmerica className={classes.ico} size={20} />
                  )}
                  {i === 3 && <FaTruck className={classes.ico} size={20} />}
                </div>
                <p className="w-50 ps-3 m-0">{l}</p>
              </div>
            ))}
            {/* <p>{content.section3.disclaimer}</p> */}
          </Col>
          <Col xs={12} lg={9}>
            <h3>{content.section3.title}</h3>
            <p>{content.section3.para}</p>
            <ul>
              {content.section3.list.map((l, i) => (
                <li className="my-1" key={i}>
                  <span className="fw-bold">{l.title}&nbsp;</span>
                  <span>{l.desc}</span>
                </li>
              ))}
            </ul>
            <p>{content.section3.note}</p>
          </Col>
        </Row>
      </section>
      {/* section4 */}
      <section className="my-5 container">
        <Card className={classes.cardBg}>
          <CardBody className="p-5">
            <div className="text-center">
              <h3>{content.section4.title}</h3>
              <p>{content.section4.para}</p>
            </div>
            <Row>
              {content.section4.services.map((s, i) => (
                <Col xs={12} lg={4} key={i}>
                  <Link className="my-3 d-block" href={`/partners${s.link}`}>
                    <Card className={classes.serviceCard}>
                      <CardBody className="text-white">
                        <h5>{s.title}</h5>
                        <p>{s.desc}</p>
                      </CardBody>
                    </Card>
                  </Link>
                </Col>
              ))}
            </Row>
          </CardBody>
        </Card>
      </section>
      {/* section6 */}
      <section className="my-5 container">
        <Row>
          <Col xs={12} lg={3}>
            <h3>{content.section5.title}</h3>
            <p>{content.section5.para}</p>
          </Col>
          <Col xs={12} lg={9}>
            {/*@ts-ignore*/}
            <Accordion open={open} toggle={toggle}>
              {content.section5?.faqs?.map((f, i) => (
                <AccordionItem key={i}>
                  <AccordionHeader targetId={(i + 1).toString()}>
                    {f.title}
                  </AccordionHeader>
                  <AccordionBody accordionId={(i + 1).toString()}>
                    <p>{f.desc}</p>
                  </AccordionBody>
                </AccordionItem>
              ))}
            </Accordion>
          </Col>
        </Row>
      </section>
      {/* section6 */}
      <section className="my-5 container">
        <h3>{content.section6.title}</h3>
        <IntegrationDetails partnerDetails={content} />
      </section>
    </main>
  );
}
